"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
class Collection extends Array {
    constructor(collectionReference) {
        super();
        this.collectionReference = collectionReference || index_1.firestore.collection("version");
        this.id = this.collectionReference.id;
        this.path = this.collectionReference.path;
        this.parent = this.collectionReference.parent;
    }
    doc(id, type) {
        const ref = this.collectionReference.doc(id);
        return type.init(ref);
    }
}
exports.Collection = Collection;
//# sourceMappingURL=Collection.js.map